<template>
  <div class="ui styled accordion">
    <div v-for="(client) in filteredClients">
      <div class="title">
        <!-- featured icon -->
        <div v-if="isFeaturedClient(client)"
             class="ui blue ribbon label">Kiemelt
        </div>
        <!-- ./featured icon -->
        <div class="row align-middle">
          <!-- logo and name -->
          <div class="small-5 medium-3 columns open-accord"
               @click="selectClient(client.domain)">
            <i class="dropdown icon"></i>
            <img :src="client.logo"
                 class="list-logo-img"/>
            {{ client.name }}
          </div>
          <!-- ./logo and name -->
          <!-- address -->
          <div class="small-7 medium-4 columns distance">
            <!-- distance -->
            <span v-if="getGoogleDirectionUrl(client)">
              <a :href="getGoogleDirectionUrl(client)"
                 data-push="false"
                 target="_blank">
                {{ client.city }} {{ client.address }} |
                <i class="location arrow icon"></i>
                {{ getDistanceText(client.lat, client.lng) }} km távolság
              </a>
            </span>
            <span v-else>{{ client.city }} {{ client.address }} | {{ getDistanceText(client.lat, client.lng) }} km távolság</span>
            <!-- ./distance -->
          </div>
          <!-- ./address -->
          <!-- client subjects -->
          <div class="small-10 medium-3 columns">
            <span v-for="globalSubjectType in client.availableGlobalSubjectTypes">
                <img :src="getGlobalSubjectTypeByKey(globalSubjectType).iconUrl"
                     :title="getGlobalSubjectTypeByKey(globalSubjectType).name"
                     class="subject-type-icon"/>
            </span>
          </div>
          <!-- ./client subjects -->
          <!-- favorite icon -->
          <div class="small-2 medium-1 medium-offset-1">
            <a v-if="isLoggedIn"
               class="favorite-wrapper">
              <i v-if="!isThisMyFavoriteClient(client.domain)"
                 class="star icon"
                 @click="favoriteClientClick(client.domain)"></i>
              <i v-else
                 class="star icon selected"
                 @click="favoriteClientClick(client.domain)"></i>
            </a>
          </div>
          <!-- ./favorite icon -->
        </div>
      </div>
      <div class="content">
        <div class="transition hidden ">
          <schedule-table-container :container-client-domain="client.domain"
                                    :is-logged-in="isLoggedIn"
                                    :is-mobile-device="isMobileDevice"
                                    @create-new-reservation="createNewReservation"
                                    @resign-reservation="resignReservation"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleTableContainer from '../schedule/ScheduleTableContainer'

export default {
  props: ['filteredClients', 'isMobileDevice', 'isLoggedIn', 'isFeaturedClient', 'getGoogleDirectionUrl',
    'getGlobalSubjectTypeByKey', 'getDistanceText', 'favoriteClientClick', 'isThisMyFavoriteClient',
    'currentPaginationPage'],
  methods: {
    selectClient (domain) {
      this.$store.dispatch('selectClient', domain);
    },
    createNewReservation (payload) {
      this.$emit('create-new-reservation', payload)
    },
    resignReservation (payload) {
      this.$emit('resign-reservation', payload)
    },

  },
  mounted: function () {
    this.$nextTick(function () {
      /* eslint-disable */
      /*
      $('.ui.accordion')
        .accordion()
      ;
      */

      $('.ui.accordion')
        .accordion({
          selector: {
            trigger: '.title .row .open-accord',
          },
        })
      ;
    })
  },
  components: {
    ScheduleTableContainer,
  },
}
</script>

<style scoped>
.ui.styled.accordion {
  margin: 0 auto;
  width: 1200px;
  border: 1px solid rgba(34, 36, 38, .15);
  border-radius: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.title > .row {
  width: 100%;
  max-width: 100%;
}

.list-logo-img {
  max-width: 3rem;
}

.subject-type-icon {
  max-width: 2rem;
  margin-right: 0.5rem;
}

.distance {
  color: rgba(0, 0, 0, .4);
  transition: color 0.5s ease;
}

.distance a {
  color: inherit;
}

.distance:hover {
  color: #1e70bf;
}

.favorite-wrapper > i {
  transition: color .1s ease;
  color: rgba(0, 0, 0, .4);
  cursor: pointer !important;
  font-size: 2rem;
}

.favorite-wrapper > i:hover {
  color: #ffb70a;
  opacity: 1;
}

.favorite-wrapper > i.selected {
  color: #ffb70a;
}

</style>
